export default __webpack_public_path__ + "static/media/f1.788500b6.svg";